const getters = {
  tokens: ({ tokens }) => tokens
}

export default getters
